"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof3 = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _user = _interopRequireDefault(require("@/api/system/user"));

var _dept = require("@/api/system/dept");

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _vuex = require("vuex");

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var userRoles = [];
var userJobs = [];
var defaultForm = {
  username: null,
  nickName: null,
  gender: '男',
  email: null,
  enabled: 'false',
  roles: [],
  jobs: [],
  dept: {
    id: null
  },
  phone: null
};
var _default = {
  name: 'UserSelect',
  components: {
    rrOperation: _RR.default,
    pagination: _Pagination.default
  },
  selectType: '',
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '用户',
      url: 'api/users/list',
      crudMethod: _objectSpread({}, _user.default)
    });
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  // 数据字典
  dicts: ['user_status'],
  props: {
    showUserSelect: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      title: '人员选择',
      options: [],
      value1: [],
      value2: [],
      userNames: [],
      nickNames: [],
      userIds: [],
      users: [],
      filterText: '',
      isFirst: true,
      height: document.documentElement.clientHeight - 180 + 'px;',
      deptName: '',
      depts: [],
      deptDatas: [],
      jobs: [],
      level: 3,
      roles: [],
      deptIds: [],
      jobDatas: [],
      roleDatas: [],
      // 多选时使用
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      },
      permission: {
        add: ['admin', 'user:add'],
        edit: ['admin', 'user:edit'],
        del: ['admin', 'user:del']
      },
      enabledTypeOptions: [{
        key: 'true',
        display_name: '激活'
      }, {
        key: 'false',
        display_name: '锁定'
      }]
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted: function mounted() {
    var that = this;

    window.onresize = function temp() {
      that.height = document.documentElement.clientHeight - 180 + 'px;';
    };
  },
  methods: (_methods = {
    onSelect: function onSelect(user) {
      this.selectUserCallBack(user); // 操作完成之后，触发父窗口的监听回调方法
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  }, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    var qDeptIds = [];
    this.deptIds.forEach(function (item) {
      qDeptIds.push(item.id);
    });
    this.query.deptIds = qDeptIds;
    return !this.isFirst;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterToCU, function (crud, form) {
    this.getRoles();

    if (form.id == null) {
      this.getDepts();
    } else {
      this.getSupDepts(form.dept.id);
    }

    this.getRoleLevel();
    this.getJobs();
    form.enabled = form.enabled.toString();
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToAdd, function () {
    this.jobDatas = [];
    this.roleDatas = [];
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToEdit, function (crud, form) {
    this.getJobs(this.form.dept.id);
    this.jobDatas = [];
    this.roleDatas = [];
    userRoles = [];
    userJobs = [];

    var _this = this;

    form.roles.forEach(function (role, index) {
      _this.roleDatas.push(role.id);

      var rol = {
        id: role.id
      };
      userRoles.push(rol);
    });
    form.jobs.forEach(function (job, index) {
      _this.jobDatas.push(job.id);

      var data = {
        id: job.id
      };
      userJobs.push(data);
    });
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterValidateCU, function (crud) {
    if (!crud.form.dept.id) {
      this.$message({
        message: '部门不能为空',
        type: 'warning'
      });
      return false;
    } else if (this.jobDatas.length === 0) {
      this.$message({
        message: '岗位不能为空',
        type: 'warning'
      });
      return false;
    } else if (this.roleDatas.length === 0) {
      this.$message({
        message: '角色不能为空',
        type: 'warning'
      });
      return false;
    }

    crud.form.roles = userRoles;
    crud.form.jobs = userJobs;
    return true;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterRefresh, function (crud) {
    var _this2 = this;

    var users = crud.data;
    users.forEach(function (user) {
      var index = _this2.userNames.indexOf(user.username);

      if (index >= 0) {
        _this2.$refs.table.toggleRowSelection(user);
      }
    });
  }), (0, _defineProperty2.default)(_methods, "getDeptDatas", function getDeptDatas(node, resolve) {
    var _this3 = this;

    if (this.isFirst !== true && (0, _typeof2.default)(node) === 'object' && node.data && node.data.hasChildren === false && typeof resolve === 'function') {
      resolve([]);
      return;
    }

    var sort = 'id,desc';
    var params = {
      sort: sort
    }; // 如果node是字符串，使用它作为deptName

    if (typeof node === 'string') {
      this.deptName = node;
    }

    if (this.isFirst === true) {
      params['name'] = this.deptName;
      this.isFirst = false;
      setTimeout(function () {
        (0, _dept.getTypeList)(node).then(function (res) {
          if (typeof resolve === 'function') {
            resolve(res.content);
            _this3.deptIds = res.content;

            _this3.handleNodeClick(_this3.deptIds);
          } else {
            _this3.deptIds = res.content;
            _this3.deptDatas = res.content;
          }

          _this3.crud.toQuery();
        });
      }, 100);
    } else {
      if ((0, _typeof2.default)(node) !== 'object') {
        if (node) {
          params['name'] = this.deptName;
        }
      } else if (node.level !== 0) {
        params['pid'] = node.data.id;
      }

      setTimeout(function () {
        (0, _dept.getDeptsByName)(params).then(function (res) {
          if (typeof resolve === 'function') {
            resolve(res.content);
            _this3.deptIds = res.content;

            _this3.handleNodeClick(_this3.deptIds);
          } else {
            _this3.deptIds = res.content;
            _this3.deptDatas = res.content;
          }

          _this3.crud.toQuery();
        });
      }, 100);
    }
  }), (0, _defineProperty2.default)(_methods, "handleNodeClick", function handleNodeClick(data) {
    if (data.pid === 0) {
      this.query.deptId = null;
    } else {
      this.query.deptId = data.id;
    }

    this.crud.toQuery();
  }), (0, _defineProperty2.default)(_methods, "changeEnabled", function changeEnabled(data, val) {
    var _this4 = this;

    this.$confirm('此操作将 "' + this.dict.label.user_status[val] + '" ' + data.username + ', 是否继续？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      _user.default.edit(data).then(function (res) {
        _this4.crud.notify(_this4.dict.label.user_status[val] + '成功', _crud.default.NOTIFICATION_TYPE.SUCCESS);
      }).catch(function () {
        data.enabled = !data.enabled;
      });
    }).catch(function () {
      data.enabled = !data.enabled;
    });
  }), (0, _defineProperty2.default)(_methods, "checkboxT", function checkboxT(row, rowIndex) {
    // return row.id !== this.user.id
    return true;
  }), (0, _defineProperty2.default)(_methods, "selectUserCallBack", function selectUserCallBack(user) {
    // 这个名称是自定义的
    // 添加完后发射监听事件
    var params = user;
    params['selectType'] = this.selectType;
    this.$emit('select-user-callBack', params); // 其中listen-add-user即为父窗口申明时所用的@listen-add-user
  }), (0, _defineProperty2.default)(_methods, "closeWin", function closeWin() {
    // 这个名称是自定义的
    // 添加完后发射监听事件
    var params = [];
    this.$emit('close', params); // 其中listen-add-user即为父窗口申明时所用的@listen-add-user

    this.crud.data = [];
  }), (0, _defineProperty2.default)(_methods, "onCloseWin", function onCloseWin() {
    this.showUserSelect = false;
  }), (0, _defineProperty2.default)(_methods, "doAllowUsers", function doAllowUsers() {
    var params = this.user;
    params['userNames'] = this.userNames;
    params['nickNames'] = this.nickNames;
    this.selectUserCallBack(params); // 操作完成之后，触发父窗口的监听回调方法

    this.closeWin(); // 关闭对话框
  }), (0, _defineProperty2.default)(_methods, "removeUser", function removeUser(nickName) {
    var _this5 = this;

    var index = this.nickNames.indexOf(nickName);

    if (index != -1) {
      this.userNames.splice(index, 1);
      this.nickNames.splice(index, 1);
      var users = this.crud.data;
      users.forEach(function (user) {
        if (nickName == user.nickName) {
          _this5.$refs.table.toggleRowSelection(user);
        }
      });
    }
  }), (0, _defineProperty2.default)(_methods, "selectUser", function selectUser(selection, row) {
    // 确保userNames和nickNames是数组
    if (!Array.isArray(this.userNames)) {
      this.userNames = [];
    }

    if (!Array.isArray(this.nickNames)) {
      this.nickNames = [];
    }

    var index = this.nickNames.indexOf(row.nickName);

    if (index == -1) {
      this.nickNames.push(row.nickName);
      this.userNames.push(row.username);
    } else {
      this.userNames.splice(index, 1);
      this.nickNames.splice(index, 1);
    }
  }), _methods)
};
exports.default = _default;